import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { token } from 'odyssey';

export const FromPriceWrapper = styled.div`
  color: ${token('color-text-dark')};
  font-size: ${token('font-size-xs')};
  font-weight: ${token('font-weight-md')};

  ${media.md`
    font-size: ${token('font-size-sm')};
  `};
`;

export const FromWrapper = styled.span`
  font-weight: ${token('font-weight-rg')};
  color: ${token('color-grey-2-neutral')};
`;
